export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بعد تأكيد التحويل الخارجي، سيتم إجراء تحويل داخلي تلقائي من حسابك إلى حساب المتداول، وسيتم إتمام الصفقة."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد استلام التحويل وإتمام الصفقة؟"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نعم، تأكيد"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا، إبقاء نشطًا"])}
}